import Vue from 'vue';

import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-direct-debit-files-tabs',
  components: {},
})
export default class DirectDebitFilesTabs extends Vue {}
